// extracted by mini-css-extract-plugin
module.exports = {"root":"PriceFilterPopup_root__2anVq","label":"PriceFilterPopup_label__1MXv6","labelSelected":"PriceFilterPopup_labelSelected__3LcKU"};